import { useMemo } from "react";
import MetaService from "../services/meta";

export const Copyright = () => {
  const logo: string = useMemo(() => MetaService.logoUrl(), []);

  return (
    <>
      <span className="text-sm">Powered by</span>
      <img
        src={logo}
        alt="noteserve logo"
        className="logo-cursor align-self-start ml-2"
        style={{ height: "20px", marginTop: "3.5px" }}
      />
    </>
  );
};
